import { render, staticRenderFns } from "./HomeAlerts.vue?vue&type=template&id=51233d19"
import script from "./HomeAlerts.vue?vue&type=script&lang=js"
export * from "./HomeAlerts.vue?vue&type=script&lang=js"
import style0 from "./HomeAlerts.vue?vue&type=style&index=0&id=51233d19&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports